module.exports = __webpack_public_path__ + "static/media/log_4.654697ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/manual/log_4.jpg
// module id = 1893
// module chunks = 0